import { createContext, useContext } from 'react';
import type { MapLibreMap } from 'maplibre-gl';

export type MapContextValue = {
  map: MapLibreMap;
  loaded: boolean;
};

const MapContext = createContext<MapContextValue | null>(null);

export const MapProvider = MapContext.Provider;

export const useMap = (): MapContextValue => {
  const value = useContext(MapContext);
  if (!value) {
    throw new Error('useMap must be used inside a <MapComponent>');
  }
  return value;
};
